// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"83216236","20":"86def496","186":"5172bd68","206":"3099cd30","225":"392a9b5b","368":"3f4fad2e","389":"a5d37034","428":"2046435a","521":"d903fe61","655":"b40fcf5e","656":"8b8fb3c3","749":"17bfb922","832":"c14076a6"}[chunkId] + ".chunk.js";
};